import { MapOverlayContainer } from '../../../../../app-kit/components/PcaMap/subcomponents/MapOverlayContainer/MapOverlayContainer';
import type { LabelWithCoordinates } from '../../../../../app-kit/components/PcaMap/types';
import {
  paletteHelper,
  spacingHelper,
  typographyHelper,
  radiusHelper,
} from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import { useContext } from 'react';
import styled from 'styled-components';
import { PcaMapContext } from '../../../../contexts/PcaMapContext/PcaMapContext';

interface PropertyBoundaryLandAreaLabelsProps {
  propertyBoundaryLandAreas?: LabelWithCoordinates[] | null;
}

const LandAreaLabel = styled.div`
  background-color: ${paletteHelper('backgroundPrimaryHigh')};
  color: ${paletteHelper('textBrand')};
  border-radius: ${radiusHelper('medium')};
  border: 1px solid ${paletteHelper('textBrand')};
  font-size: ${typographyHelper('overline')};
  text-transform: none;
  padding: ${spacingHelper('twoExtraSmall extraSmall')};
`;

export const PropertyBoundaryLandAreaLabels: FunctionComponent<
  PropertyBoundaryLandAreaLabelsProps
> = ({ propertyBoundaryLandAreas }) => {
  const { isLoading, map } = useContext(PcaMapContext);
  return (
    <>
      {!isLoading &&
        map &&
        propertyBoundaryLandAreas &&
        propertyBoundaryLandAreas.map((landArea) => {
          return (
            <MapOverlayContainer
              key={`${landArea.coordinates.latitude},${landArea.coordinates.longitude}`}
              position={{
                lat: landArea.coordinates.latitude,
                lng: landArea.coordinates.longitude,
              }}
              minZoomLevelToDisplayOverlay={17}
              // minZoomLevelToDisplayOverlay is set here to the zoom level at which google maps generally shows building boundaries.
              // See: https://developers.google.com/maps/documentation/maps-static/start#Zoomlevels
              map={map}
            >
              <LandAreaLabel>{landArea.label}</LandAreaLabel>
            </MapOverlayContainer>
          );
        })}
    </>
  );
};
